import { useEffect, useRef } from "react";
import { Box, Flex, Heading, IconButton } from "@chakra-ui/react";
import { X } from "lucide-react";
import { colors } from "@/theme/colors";

export const Modal = ({ open, onClose, title, children, testId }) => {
  const panelRef = useRef(null);
  // Focus the panel ONLY when the modal opens — never on subsequent re-renders,
  // otherwise typing (which re-renders the parent and recreates onClose) would
  // steal focus from the active input on every keystroke.
  useEffect(() => {
    if (open) panelRef.current?.focus();
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const titleId = `${testId || "modal"}-title`;
  return (
    <Box position="fixed" inset="0" zIndex={100} display="flex" alignItems="center" justifyContent="center" p="4" data-testid={testId}>
      <Box position="absolute" inset="0" bg="rgba(31,41,55,0.45)" onClick={onClose} />
      <Box
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        outline="none"
        position="relative"
        bg={colors.white}
        borderRadius="16px"
        border="1px solid"
        borderColor={colors.border}
        w="full"
        maxW="480px"
        p="6"
        zIndex={1}
        maxH="90vh"
        overflowY="auto"
        boxShadow="0 12px 32px rgba(31,41,55,0.16)"
      >
        <Flex justify="space-between" align="center" mb="5">
          <Heading id={titleId} fontFamily="heading" fontWeight="700" fontSize="lg" color={colors.textPrimary}>
            {title}
          </Heading>
          <IconButton aria-label="Close" variant="ghost" size="sm" onClick={onClose} _hover={{ bg: colors.cream }} data-testid="modal-close">
            <X size={18} />
          </IconButton>
        </Flex>
        {children}
      </Box>
    </Box>
  );
};
